export const SMALL_CONTAINER_WIDTH = 480;

export const DIALOG_PORTAL_CONTAINER_ID = 'main'; // used for full-screen picker fields
